import React, { FunctionComponent } from 'react';

import { closeCurrentPopup } from '@paragon/popup-state';

import { saveTrussEnvelopes } from '../../store/actions/layout/trussEnvelopeActions';
import { FlipTrussEnvelopeDialogProps } from '../../store/actions/popupActions';
import { useAppDispatch } from '../hooks';
import { ConfirmDialog } from './ConfirmDialog';

export const FlipTrussEnvelopeConfirmDialog: FunctionComponent<FlipTrussEnvelopeDialogProps> = ({
  flippedEnvelopes,
}) => {
  const dispatch = useAppDispatch();

  const message =
    flippedEnvelopes.length === 1
      ? 'Flipping this envelope will unlink it from the component design. Are you sure you want to proceed?'
      : 'Flipping these envelopes will unlink them from their component designs. Are you sure you want to proceed?';

  return (
    <ConfirmDialog
      open
      title="Confirm Unlink"
      message={message}
      onClose={(confirmed) => {
        dispatch(closeCurrentPopup());
        if (confirmed)
          dispatch(
            saveTrussEnvelopes(
              flippedEnvelopes.map((flippedEnvelope) => ({ ...flippedEnvelope, componentDesignGuid: null })),
            ),
          );
      }}
    />
  );
};
